export default __webpack_public_path__ + "static/media/has-on-site.2b62d418.svg";